import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../common/inputs/button';

const Header = props => {
  const {
    disabledExportButton,
    loadingExportButton,
    handleExportButton
  } = props;
  return (
    <div className="entity_header calculations_history_header">
      <div className='entity_title'>
         <FormattedMessage id="preCalculationsHistory.title"/>
      </div>
      <div className="entity_header_buttons_wrapper">     
        {handleExportButton && (
          <Button
            loading={loadingExportButton}
            disabled={disabledExportButton || loadingExportButton}
            onClick={handleExportButton}
            labelLocale={<FormattedMessage id="calculationsHistory.exportButtonTitle"/>}
          />
        )}
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/preCalculationsHistory/header.jsx